// extracted by mini-css-extract-plugin
module.exports = {"container":"CookiesDesktop_container__3I4cC","button":"CookiesDesktop_button__33roj"};